export const DashboardConfig = {
    name            : 'Dashboard',
    menuName        : 'Dashboard',
    icon            : 'i5-dashboard',
    image           : 'dashboard',
    iconSvg         : 'isvg-view-dashboard',
    url             : 'dashboard',
    stringId        : 'dashboard',
    description     : 'Dashboard with customized widgets grid',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_DASHBOARD_CONFIG = {
    ...DashboardConfig,
    // key2: "newValue2",  // Replacing the value for key2
}